import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';

/**
 * Free-solo Autocomplete used by the SharingAgreementV2 quick-add bars
 * (`QuickAddSelectorBar` and `SelectorPathKeysQuickAdd`).
 *
 * Suggestions come from `options` (current preset reference-number keys);
 * the user can also commit a custom value. The parent owns the trimmed
 * string state and is responsible for running `validateQuickAddKey`
 * before turning the value into a stored selector / identifier line.
 *
 * Notes:
 * - Controlled via `inputValue` only — for free-solo string lookups this is
 *   simpler than juggling both `value` and `inputValue`.
 * - `getOptionLabel` is identity for plain strings.
 * - MUI v4 ergonomics aligned with the docs combo: `selectOnFocus`,
 *   `handleHomeEndKeys`, `size="small"`. `clearOnBlur` is intentionally
 *   left as the free-solo default (false) so typed values persist.
 *
 * @param {{
 *   id?: string,
 *   label: string,
 *   options: string[],
 *   value: string,
 *   onChange: (next: string) => void,
 *   disabled?: boolean,
 *   error?: boolean,
 *   helperText?: string,
 *   placeholder?: string,
 *   className?: string,
 *   name?: string,
 *   inputProps?: Record<string, unknown>
 * }} props
 */
function PresetKeyAutocomplete({
    id,
    label,
    options,
    value,
    onChange,
    disabled,
    error,
    helperText,
    placeholder,
    className,
    name,
    inputProps
}) {
    return (
        <Autocomplete
            id={id}
            className={className}
            options={options}
            inputValue={value ?? ''}
            onInputChange={(_event, newInput) => onChange(newInput ?? '')}
            getOptionLabel={(option) => String(option ?? '')}
            disabled={disabled}
            freeSolo
            selectOnFocus
            handleHomeEndKeys
            size="small"
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    placeholder={placeholder}
                    error={Boolean(error)}
                    helperText={helperText}
                    name={name}
                    inputProps={{ ...(params.inputProps || {}), ...(inputProps || {}) }}
                />
            )}
        />
    );
}

export default PresetKeyAutocomplete;
